'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var jsxRuntime = require('react/jsx-runtime');
var React = require('react');
var strings = require('../strings.js');
var utils = require('../utils.js');
var WheelCanvas = require('../WheelCanvas/WheelCanvas.js');
var Roulette = require('./Roulette.js');
var SpinBorder = require('./SpinBorder.js');
var SpinTrigger = require('./SpinTrigger.js');
var styles = require('./styles.js');

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const STARTED_SPINNING = "started-spinning";
const START_SPINNING_TIME = 2600;
const CONTINUE_SPINNING_TIME = 750;
const STOP_SPINNING_TIME = 8e3;
const Wheel = ({
  mustStartSpinning,
  prizeNumber,
  items = [],
  onStartSpinning = () => null,
  onStopSpinning = () => null,
  backgroundColors = strings.DEFAULT_BACKGROUND_COLORS,
  textColors = strings.DEFAULT_TEXT_COLORS,
  spinDuration = strings.DEFAULT_SPIN_DURATION,
  prizeAngle = strings.DEFAULT_PRIZE_ANGLE,
  spinTrigger,
  roulette,
  canvasConfig,
  loading = false
}) => {
  var _a;
  const [wheelData, setWheelData] = React.useState([...items]);
  const [startRotationDegrees, setStartRotationDegrees] = React.useState(0);
  const [finalRotationDegrees, setFinalRotationDegrees] = React.useState(0);
  const [hasStartedSpinning, setHasStartedSpinning] = React.useState(false);
  const [hasStoppedSpinning, setHasStoppedSpinning] = React.useState(false);
  const [isCurrentlySpinning, setIsCurrentlySpinning] = React.useState(false);
  const [isDataUpdated, setIsDataUpdated] = React.useState(false);
  const [classKey] = React.useState(utils.makeClassKey(5));
  const normalizedSpinDuration = Math.max(0.01, spinDuration);
  const startSpinningTime = START_SPINNING_TIME * normalizedSpinDuration;
  const continueSpinningTime = CONTINUE_SPINNING_TIME * normalizedSpinDuration;
  const stopSpinningTime = STOP_SPINNING_TIME * normalizedSpinDuration;
  const totalSpinningTime = startSpinningTime + continueSpinningTime + stopSpinningTime;
  const mustStopSpinning = React.useRef(false);
  React.useEffect(() => {
    var _a2, _b;
    const dataLength = items.length;
    const wheelDataAux = [{ name: "" }];
    for (let i = 0; i < dataLength; i++) {
      wheelDataAux[i] = __spreadProps(__spreadValues({}, items[i]), {
        style: {
          backgroundColor: ((_a2 = items[i].style) == null ? void 0 : _a2.backgroundColor) || backgroundColors[i % backgroundColors.length],
          textColor: ((_b = items[i].style) == null ? void 0 : _b.textColor) || textColors[i % textColors.length]
        }
      });
    }
    setWheelData([...wheelDataAux]);
    setIsDataUpdated(true);
  }, [items, backgroundColors, textColors]);
  React.useEffect(() => {
    if (mustStartSpinning && !isCurrentlySpinning) {
      setIsCurrentlySpinning(true);
      startSpinning();
      const finalRotationDegreesCalculated = utils.getRotationDegrees(
        prizeNumber,
        items.length,
        prizeAngle
      );
      setFinalRotationDegrees(finalRotationDegreesCalculated);
    }
  }, [mustStartSpinning]);
  React.useEffect(() => {
    if (hasStoppedSpinning) {
      setIsCurrentlySpinning(false);
      setStartRotationDegrees(finalRotationDegrees);
    }
  }, [hasStoppedSpinning]);
  const startSpinning = () => {
    setHasStartedSpinning(true);
    setHasStoppedSpinning(false);
    mustStopSpinning.current = true;
    setTimeout(() => {
      if (mustStopSpinning.current) {
        mustStopSpinning.current = false;
        setHasStartedSpinning(false);
        setHasStoppedSpinning(true);
        onStopSpinning();
      }
    }, totalSpinningTime);
  };
  const getRouletteClass = () => {
    if (hasStartedSpinning) {
      return STARTED_SPINNING;
    }
    return "";
  };
  if (!isDataUpdated) {
    return null;
  }
  return /* @__PURE__ */ jsxRuntime.jsxs(styles.RouletteContainer, {
    children: [
      /* @__PURE__ */ jsxRuntime.jsx(styles.RotationContainer, {
        className: getRouletteClass(),
        startSpinningTime,
        continueSpinningTime,
        stopSpinningTime,
        startRotationDegrees,
        finalRotationDegrees,
        classKey,
        children: /* @__PURE__ */ jsxRuntime.jsx(WheelCanvas, __spreadValues({
          width: "900",
          height: "900",
          items: wheelData
        }, canvasConfig))
      }),
      /* @__PURE__ */ jsxRuntime.jsx(SpinBorder.SpinBorder, {
        image: (_a = canvasConfig == null ? void 0 : canvasConfig.border) == null ? void 0 : _a.image
      }),
      /* @__PURE__ */ jsxRuntime.jsx(Roulette.Roulette, __spreadValues({
        prizeAngle
      }, roulette)),
      /* @__PURE__ */ jsxRuntime.jsx(SpinTrigger.SpinTrigger, __spreadProps(__spreadValues({
        onStartSpinning
      }, spinTrigger), {
        loading
      }))
    ]
  });
};

exports.Wheel = Wheel;
